<template>
    <div class="top-header-root">
        <div class="top-header-spacer" aria-hidden="true"></div>
        <div
            class="top-header-fixed"
            :class="{
                'top-header-fixed--light': !!color,
                'top-header-fixed--ar': !color && $i18n.locale === 'ar',
            }"
        >
            <div class="hound">
                <img
                    v-if="!color"
                    class="returns"
                    @click="returnBtn"
                    src="../../assets/h5/back.png"
                    alt=""
                />
                <img
                    v-else
                    class="returns"
                    @click="returnBtn"
                    src="../../assets/h5/back2.png"
                    alt=""
                />
                <p
                    :style="{
                        color: color,
                    }"
                >
                    {{ text }}
                </p>
                <span
                    class="history-btn"
                    v-if="historyBtn"
                    @click="toHistoryPage"
                ></span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:"top-header",
        props:["text","color",'historyBtn','guildId','guildUid','toUrl'],
        data() {
            return {
                isLogin: false,
                userInfo: {},
            }
        },
        mounted() {
        },
        methods: {
            returnBtn() {
                // historybtn为真  在点击返回说明需要关闭webview
                if(this.historyBtn){
                    return this.$completes.complete("getPreviousPage");
                }
                if (window.history.length <= 1) {
                    // 没有上一页，关闭webview
                    this.$completes.complete("getPreviousPage");
                } else {
                    this.$router.go(-1);
                }
            },
            // 跳转到历史记录
            toHistoryPage(){
                console.log(this.toUrl)
                this.$router.push({ 
                    path: "/withdrawal-history",
                    query: { 
                        guildId:this.guildId,
                        guildUid:this.guildUid,
                        toUrl: this.toUrl
                    }
                 });
            }
        }
    }
</script>
<style>
    .top-header-root {
        position: relative;
        width: 100%;
    }
    /* 与 .hound 总高度一致（border-box height:130px，含 safe-area padding）（2026-05-08） */
    .top-header-spacer {
        width: 100%;
        height: 130px;
        flex-shrink: 0;
        pointer-events: none;
    }
    .top-header-fixed {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
    }
    .top-header-fixed--light {
        /* background: #fff; */
    }
    .top-header-fixed:not(.top-header-fixed--light):not(.top-header-fixed--ar) {
        background: url("../../assets/withdrawal/headBg.png") no-repeat center top;
        background-size: 100% 480px;
    }
    .top-header-fixed.top-header-fixed--ar:not(.top-header-fixed--light) {
        background: url("../../assets/withdrawal/headBg_ar.png") no-repeat center top;
        background-size: 100% 100%;
    }
    html[lang="ar"] .returns {
        /* -webkit-transform: rotateY(180deg); */
        right: 28px;
        transform: rotateY(180deg);
    }
    html[lang="ar"] .history-btn {
        left: 28px;
        right: auto;
        transform: rotateY(180deg);
    }
    html[lang="ar"] .hound p{
        padding-left: 0;
        padding-right: 40px;
    }
    .hound {
        width: 100%;
        height: 130px;
        display: flex;
        align-items: center;
        padding-top: 30px;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        box-sizing: border-box;
        position:relative;
        padding-top: calc(30px + env(safe-area-inset-top));
        padding-top: calc(30px + constant(safe-area-inset-top)); 
    }
    .hound p {
        flex: 1;
        font-size: 30px;
        font-weight: 600;
        color: #fff;
        text-align: center;
        font-family: 'Mada';
        /* padding-left: 40px; */
    }
    .returns {
        /* width: 0.8rem;
        height: 0.8rem; */
        width: 28px;
        height: 28px;
        position: absolute;
    }
    .history-btn{
        /* position: absolute; */
        /* top: 47%; */
        right: 28px;
        width: 40px;
        height: 40px;
        top: calc(47% + env(safe-area-inset-top));
        background: url("../../assets/withdrawal/history-btn.png") no-repeat;
        background-size: 100% 100%;
    }
</style>